export const ArrowUp = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path opacity="0.4" d="M16 4L6 14L7.41 15.41L15 7.83V28H17V7.83L24.59 15.41L26 14L16 4Z" fill="currentColor"/>
<path d="M6.5899 13.7079L16 4.41025L25.3195 13.6744" stroke="currentColor" stroke-width="2"/>
<path d="M16.0055 26.9992L16.0055 4.99924" stroke="currentColor" stroke-width="2"/>
</svg>`;
